// extracted by mini-css-extract-plugin
export default {"discoverInformal1to1Container":"RpD19fpOooq8SN6Maw4e","text":"g4OimeSGxa2GKd2TfNwe","separator":"q9zDlkcot6xj7r0u46gs","border":"EAQhD0Jto5IuEj3E6Mg7"};